class CtxContentSwitcherService {
    constructor($timeout, $q) {
        this.$timeout = $timeout;
        this.$q = $q;
    }

    customAnimation(rootElement, minHeight) {
        let switcher = rootElement.find('.ctx-content-switcher'), switcherHeight, switcherPanel, panelHeight, height;
        if (switcher && switcher[0]) switcher.css({ overflow: 'hidden' });

        this.$timeout(() => {
            if (!switcher || !switcher[0]) switcher = rootElement.find('.ctx-content-switcher');
            if (!switcher || !switcher[0]) return;
            switcherHeight = switcher[0].getBoundingClientRect().height;
            switcherPanel = rootElement.find('ctx-switch-panel');
            panelHeight = switcherPanel[0] ? (switcherPanel[0].getBoundingClientRect().height) : 0;
            height = minHeight && minHeight > 0 && minHeight > Math.round(panelHeight) ? minHeight : panelHeight;

            if (switcherHeight !== height) {
                switcher.css({ overflow: 'hidden' });
                switcher.animate({ height: height + 'px' }, 250, () => {
                    switcher.css({ overflow: 'visible' });
                });
            } else {
                switcher.css({ overflow: 'visible' });
            }
        }, 200);
    }

    removeAutoHeight(switcher) {
        return this.$q(function (resolve) {
            switcher.css({ 'height': switcher.height() });
            resolve();
        });
    }

}

CtxContentSwitcherService.$inject = ['$timeout', '$q'];

module.exports = CtxContentSwitcherService;



// WEBPACK FOOTER //
// ./src/shared/ctxContentSwitcher/ctxContentSwitcher.service.js